type RouteImportFunction = () => Promise<unknown>;

const routeImports: Record<string, RouteImportFunction> = {
  dashboard: () => import('../pages/dashboard/DashboardPage.jsx'),
  scorecard: () => import('../pages/scorecard/ScorecardEntryPage'),
  profile: () => import('../pages/user/ProfilePage.jsx'),
};

const prefetchedRoutes = new Set<string>();

export const prefetchRoute = (routeName: string): void => {
  if (prefetchedRoutes.has(routeName)) {
    return;
  }

  const importFn = routeImports[routeName];
  if (importFn) {
    importFn()
      .then(() => {
        prefetchedRoutes.add(routeName);
      })
      .catch((error) => {
        console.error(`Failed to prefetch route ${routeName}:`, error);
      });
  }
};

